import React, { useEffect } from 'react'
import { Header } from '../components/layout/Header'
import { Footer } from '../components/layout/Footer'
import SEO from '../components/SEO'

const Contact: React.FC = () => {
  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])

  return (
    <div className="min-h-screen bg-white font-sans text-fg-2">
      <SEO 
        title="Contact Us | Jobloads" 
        description="Get in touch with Jobloads. We're here to help with workforce coordination and attendance reliability solutions."
        canonicalPath="/contact"
      />
      <Header />
      
      <main className="max-w-[1200px] mx-auto px-8 py-12 md:py-32">
        <div className="max-w-[720px]">
          <div className="sec-label">
            <span className="num">04</span>
            <span className="rule"></span>
            <span>Get in touch</span>
          </div>
          
          <h1 className="mt-6 text-[clamp(42px,8vw,88px)] font-semibold leading-[1.02] tracking-[-0.03em] text-midnight-blue mb-8">
            How can we help?
          </h1>
          
          <p className="text-[20px] md:text-[22px] leading-[1.55] text-fg-3 font-subheading mb-12">
            Whether you're looking to improve attendance reliability for your workforce or have questions about Crewloads, we're ready to start the conversation.
          </p>

          <div className="grid md:grid-cols-2 gap-12 mt-16">
            <div className="p-8 bg-pebble border border-stone rounded-2xl">
              <div className="text-xs font-semibold text-fg-4 mb-4 uppercase tracking-wider">Email us</div>
              <a 
                href="mailto:hello@jobloads.com" 
                className="text-[24px] font-semibold text-midnight-black hover:text-teal transition-colors break-all"
              >
                hello@jobloads.com
              </a>
              <p className="mt-4 text-[17px] text-fg-4">
                We typically respond within 24 hours.
              </p>
            </div>

            <div className="p-8 bg-midnight-black text-white rounded-2xl relative overflow-hidden">
              <div className="pattern pattern--teal opacity-[0.08] bg-[length:180px]"></div>
              <div className="relative z-10">
                <div className="text-xs font-semibold text-white/50 mb-4 uppercase tracking-wider">Follow our journey</div>
                <div className="space-y-4">
                  <a 
                    href="https://www.facebook.com/jobloads" 
                    target="_blank" 
                    rel="noopener noreferrer"
                    className="block text-[20px] font-semibold text-white hover:text-teal transition-colors"
                  >
                    Facebook
                  </a>
                  <a 
                    href="https://www.instagram.com/jobloads" 
                    target="_blank" 
                    rel="noopener noreferrer"
                    className="block text-[20px] font-semibold text-white hover:text-teal transition-colors"
                  >
                    Instagram
                  </a>
                  <a 
                    href="https://candicepardy.com" 
                    target="_blank" 
                    rel="noopener noreferrer"
                    className="block text-[20px] font-semibold text-white hover:text-teal transition-colors"
                  >
                    Founder's Website
                  </a>
                </div>
              </div>
            </div>
          </div>

          <div className="mt-20 pt-20 border-t border-stone">
            <h2 className="text-[28px] font-semibold text-midnight-black mb-6">Location</h2>
            <p className="text-[19px] text-fg-3 leading-relaxed">
              Based in Gisborne, New Zealand.<br />
              Building for workforces everywhere.
            </p>
          </div>
        </div>
      </main>

      <Footer />
    </div>
  )
}

export default Contact
